import { Model } from '@/models/Model'
import Property from '@/decorators/Property'
import { ToOneRelation } from 'coloquent/dist/relation/ToOneRelation'
import { CargoType } from '@/models/CargoType'
import { Terminal } from '@/models/Terminal'
import { Transport } from '@/models/Transport'
import { TerminalSrsLocation } from '@/models/TerminalSrsLocation'
import { CustomLocation } from './CustomLocation'

export class LCIReport extends Model {
	protected jsonApiType = 'lciReports'

	@Property()
	public skipperName!: string

	@Property()
	public client!: string

	@Property()
	public customStartLocationPlace!: string | null

	@Property()
	public customDestinationLocationPlace!: string | null

	private transport(): ToOneRelation {
		return this.hasOne(Transport, 'transport')
	}

	public getTransport(): Transport {
		return this.getRelation('transport')
	}

	public setTransport(transport: Transport): void {
		this.setRelation('transport', transport)
	}

	private cargoTypeLastTransported(): ToOneRelation {
		return this.hasOne(CargoType, 'cargoTypeLastTransported')
	}

	public setCargoTypeLastTransported(type: CargoType | null) {
		this.setRelation('cargoTypeLastTransported', type)
	}

	private cargoTypeSecondLastTransported(): ToOneRelation {
		return this.hasOne(CargoType, 'cargoTypeSecondLastTransported')
	}

	public setCargoTypeSecondLastTransported(type: CargoType | null) {
		this.setRelation('cargoTypeSecondLastTransported', type)
	}

	private cargoTypeThirdLastTransported(): ToOneRelation {
		return this.hasOne(CargoType, 'cargoTypeThirdLastTransported')
	}

	public setCargoTypeThirdLastTransported(type: CargoType | null) {
		this.setRelation('cargoTypeThirdLastTransported', type)
	}

	public startTerminal(): ToOneRelation {
		return this.hasOne(Terminal, 'startTerminal')
	}

	public setStartTerminal(terminal: Terminal | null): void {
		return this.setRelation('startTerminal', terminal)
	}

	public destinationTerminal(): ToOneRelation {
		return this.hasOne(Terminal, 'destinationTerminal')
	}

	public setDestinationTerminal(terminal: Terminal | null): void {
		return this.setRelation('destinationTerminal', terminal)
	}

	public startTerminalSrsLocation(): ToOneRelation {
		return this.hasOne(TerminalSrsLocation, 'startTerminalSrsLocation')
	}

	public setStartTerminalSrsLocation(terminalSrsLocation: TerminalSrsLocation | null): void {
		return this.setRelation('startTerminalSrsLocation', terminalSrsLocation)
	}

	private customStartLocation(): ToOneRelation {
		return this.hasOne(CustomLocation, 'customStartLocation')
	}

	public setCustomStartLocation(customLocation: CustomLocation | null): void {
		return this.setRelation('customStartLocation', customLocation)
	}

	private destinationTerminalSrsLocation(): ToOneRelation {
		return this.hasOne(TerminalSrsLocation, 'destinationTerminalSrsLocation')
	}

	public setDestinationTerminalSrsLocation(terminalSrsLocation: TerminalSrsLocation | null): void {
		return this.setRelation('destinationTerminalSrsLocation', terminalSrsLocation)
	}
}
